module.exports = __webpack_public_path__ + "media/sub2-6-3.0e402005.mp4";